<template>
  <div class="ds-wrap">
    <span class="ds-lbl">
      {{ label }}<template v-if="value > 0"> · <b>{{ value }}d</b></template>
    </span>
    <input
      type="range"
      class="ds-slider"
      min="0"
      max="360"
      step="1"
      :value="value"
      @input="$emit('input', Number($event.target.value))"
    />
  </div>
</template>

<script>
export default {
  name: 'DateSlider',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    label: { type: String, required: true },
    value: { type: Number, default: 0 },
  },
  emits: ['input'],
};
</script>

<style scoped>
.ds-wrap {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
  min-width: 120px;
}

.ds-lbl {
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #7E8B97;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  line-height: 1;
}

.ds-lbl b {
  color: #12283F;
  font-weight: 700;
}

.ds-slider {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: #e2e5ea;
  outline: none;
  cursor: pointer;
  accent-color: #12283F;
}
</style>

<style>
html.dark .ds-lbl { color: rgba(214,228,240,0.4); }
html.dark .ds-lbl b { color: #d6e4f0; }
html.dark .ds-slider { background: rgba(255,255,255,0.12); accent-color: #a5a8e8; }
</style>
